import { render, staticRenderFns } from "./east-img.vue?vue&type=template&id=12848608&"
import script from "./east-img.vue?vue&type=script&lang=js&"
export * from "./east-img.vue?vue&type=script&lang=js&"
import style0 from "./east-img.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports